module.exports = __webpack_public_path__ + "img/flag-GERMANY.cbfe0c0a.svg";